import PageContainerMobile from 'components/PageContainer/layout/PageContainer.mobile'
import { IconButton } from '@material-ui/core'
import { GRAY_COLORS } from 'asterX-UI'
import ChevronLeftIcon from 'asterX-UI/Icons/ChevronLeftIcon'
import React, { useEffect } from 'react'

import { makeStyles } from '@material-ui/core/styles'
import CommentsTab from 'components/Mobile/WorkListView/CommentsTab'
import { useSelectionStore } from 'context/SelectionStore/Manager/SelectionStoreProvider.manager'

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    marginBottom: 20
  },
  heading: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px'
  }
}))
const UserComments = ({ onClose }) => {
  const classes = useStyles()
  const {
    store: { comments },
    funcs: { addComments, getAllComments }
  } = useSelectionStore()
  const tabsList = [
    {
      label: 'Все',
      value: 'COMMENTS'
    },
    {
      label: 'Результаты задачи',
      value: '@result'
    },
    {
      label: 'Причина упущенных',
      value: 'MISSING'
    },
    {
      label: 'Фин сервис',
      value: 'FINSERVICE'
    }
  ]
  useEffect(() => {
    getAllComments()
  }, [])
  return (
    <PageContainerMobile
      customHeader={
        <div className={classes.header}>
          <IconButton
            style={{
              color: GRAY_COLORS[400]
            }}
            onClick={onClose}
            size={'medium'}
          >
            <ChevronLeftIcon />
          </IconButton>
          <div className={classes.heading}>Коментарии</div>
        </div>
      }
    >
      <CommentsTab
        tabsList={tabsList}
        comments={comments}
        onAddComment={addComments}
      />
    </PageContainerMobile>
  )
}

export default UserComments
